import { forwardRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * A simple HashLink replacement for react-router-dom v6+ (no dependency)
 * Usage: <HashLink to="/#organizers">Host Organization</HashLink>
 */
const HashLink = forwardRef(({ to, scroll = true, children, ...rest }, ref) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e) => {
    const [pathname, hash] = to.split('#');
    if (pathname && location.pathname !== pathname) {
      navigate(pathname + (hash ? '#' + hash : ''));
      // Wait for navigation, then scroll
      setTimeout(() => {
        if (hash && scroll) {
          const el = document.getElementById(hash);
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 50);
    } else if (hash) {
      // Already on the page, just scroll
      e.preventDefault();
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
      // Update hash in URL
      window.history.replaceState(null, '', '#' + hash);
    }
    if (rest.onClick) rest.onClick(e);
  };

  return (
    <a
      href={to}
      ref={ref}
      {...rest}
      onClick={handleClick}
    >
      {children}
    </a>
  );
});

export default HashLink;
